<form [formGroup]="form">
    <ng-container>
        <h4><b>{{"EDITNOTE" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "MS_REQSERV_N"}}</b></h4>

        <textarea matInput formControlName="newNoteValue" type="text"></textarea>
        <mat-error *ngIf="form.controls.newNoteValue.errors != null && form.controls.newNoteValue.value.length > 255">
            Error
        </mat-error>
        <button mat-button type="submit"
            (click)="btnSetAction()">{{"btn_save" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
        <button mat-button
            (click)="onClose()">{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    </ng-container>
</form>
